import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Airport } from '@app/modules/core/interfaces/airport';
import { fetchAirportsSuccessAction } from '@app/store/actions/global.actions';

export interface AirportsState extends EntityState<Airport> { }

function getId(airline: Airport): string {
  return airline.code;
}

export const airportsAdapter: EntityAdapter<Airport> = createEntityAdapter<Airport>({
  selectId: getId
});

export const initialState: AirportsState = airportsAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(fetchAirportsSuccessAction, (state, { airports }) => {
    return airportsAdapter.setAll(airports.map(formatAirport).filter(airport => !!airport && !!airport.code), state);
  })
);

function formatAirport(airportInfo: string): Airport {
  const parts = airportInfo.split(',').map(section => section.trim());
  if (parts.length === 2) {
    return getAirportSimpleFormat(airportInfo);
  } else return getAirportFullFormat(parts);
}

function getAirportSimpleFormat(airportInfo: string): Airport {
  const airportAndCity = airportInfo
    .split(',').map(section => section.trim());
  const airportAndCode = airportAndCity[1]
    .split('(')
    .map(section => section.replace(')', '').trim());
  const code = airportAndCode[1];
  const city = airportAndCity[0];
  const name = airportAndCode[0];
  return { name, code, city, country: null };
}

function getAirportFullFormat(parts: string[]): Airport {
  const airport = parts[0];
  const city = parts[1];
  const country = parts[2];
  const airportCode = airport
    .slice(airport.indexOf('('), airport.length)
    .replace(')', '')
    .replace('(', '')
    .trim();
  const airportName = airport
    .slice(0, airport.indexOf('('))
    .trim();
  const countryName = country
    .slice(0, country.indexOf('('))
    .trim();
  return { name: airportName, code: airportCode, city, country: countryName };
}

export function airportsReducer(state: AirportsState, action: Action): AirportsState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = airportsAdapter.getSelectors();
